var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"button--light button--size-large",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-icon',{class:{
      'icon': true,
      'ml-4': _vm.text,
    },domProps:{"textContent":_vm._s('$vuetify.downArrow')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }